import { render, staticRenderFns } from "./AccountName.vue?vue&type=template&id=b90d79fa&scoped=true&"
import script from "./AccountName.vue?vue&type=script&lang=js&"
export * from "./AccountName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90d79fa",
  null
  
)

export default component.exports